<template>
  <div className="animated">
    <b-card class="animated fadeIn">
      <b-card-body>
        <h1>Pallets</h1>
        <hr />
        <v-client-table :columns="columns" :data="data" :options="options" :theme="theme" id="dataTable">
          <template slot="id" slot-scope="props">
            <input
              type="checkbox"
              :ref="'check' + props.index"
              @click="unmarkAll($event, props.row.total_net_kilograms, props.index, 'check' + props.index)"
              class="form-check"
              :value="props.row"
              v-model="markedRows"
            />
          </template>
        </v-client-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";

numeral.locale("es");

var d = new Date();

Vue.use(ClientTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "formInspeccionPallet",
  components: {
    ClientTable
  },
  mounted() {
    this.getPallet(this.selected.month, this.selected.condition, this.selected.product, this.selected.product_type);
  },
  created() {},
  data() {
    return {
      markedRows: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Pallet: "number",
        Huerto: "origins",
        Formato: "container",
        Variedad: "varieties",
        Cajas: "total_quantity",
        kilogramos_netos: "total_net_kilograms",
        kilogramos_brutos: "total_gross_kilograms"
      },
      columns: [
        "id",
        "number",
        "_origins",
        "_container",
        "_varieties",
        "_total_quantity",
        "_total_net_kilograms",
        "_total_gross_kilograms"
      ],
      selected: {
        product: "",
        product_type: "",
        condition: "",
        month: d.getMonth() + 1
      },
      selectOptions: {
        products: [],
        product_types: [],
        conditions: [
          { value: "", text: "-------" },
          { value: "Orgánico", text: "Orgánico" },
          { value: "Convencional", text: "Convencional" },
          { value: "Org. (System)", text: "Org. (System)" },
          { value: "Conv. (System)", text: "Conv. (System)" }
        ],
        months: [
          { value: 1, text: "Enero" },
          { value: 2, text: "Febrero" },
          { value: 3, text: "Marzo" },
          { value: 4, text: "Abril" },
          { value: 5, text: "Mayo" },
          { value: 6, text: "Junio" },
          { value: 7, text: "Julio" },
          { value: 8, text: "Agosto" },
          { value: 9, text: "Septiembre" },
          { value: 10, text: "Octubre" },
          { value: 11, text: "Noviembre" },
          { value: 12, text: "Diciembre" }
        ]
      },
      productSet: [],
      data: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        texts: {
          noResults: "No se encontraron registros.",
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        listColumns: {
          waybill_date: [
            {
              id: 1,
              text: "Enero"
            },
            {
              id: 2,
              text: "Febrero"
            },
            {
              id: 3,
              text: "Marzo"
            },
            {
              id: 4,
              text: "Abril"
            }
          ]
        },
        perPage: 10,
        dateFormat: "DD/MM/YYYY",
        // columnsDropdown: true,

        filterByColumn: false,
        headings: {
          id: "",
          number: "Pallet",
          _origins: "Origen",
          _container: "Contenedor",
          _varieties: "Variedad",
          _total_quantity: "Cajas",
          _total_net_kilograms: "kilogramos netos",
          _total_gross_kilograms: "kilogramos brutos"
        },
        sortable: ["number", "company_name"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      }
    };
  },
  methods: {
    getpalletscheck() {
      return this.markedRows;
    },
    unmarkAll($event, kilosNetos, index, obj) {
      //console.log($event.target.checked);

      if ($event.target.checked == false) {
        console.log("No chekiando");
      } else {
        console.log("chekiando");
      }

      this.allMarked = false;
    },
    getPallet(month, condition, product, product_type) {
      /*    const url = '/api/v1/dispatched/?' +
          'condition=' + condition +
          '&product_type__id=' + product_type +
          '&variety__product__id=' + product +
          '&dispatch_month=' + month; */

      const url = "/api/v1/pallet/inspection_pallets/";

      this.$axios
        .get(url)
        .then((res) => {
          const data = res.data;
          const items = [];
          for (let key in data) {
            const item = data[key];
            /*  data[key].waybill_date = moment(data[key].waybill_date).format('DD-MM-YYYY');
            data[key].dispatch_waybill_date = moment(data[key].dispatch_waybill_date).format('DD-MM-YYYY');
            data[key].net_kilograms = numeral(parseFloat(data[key].net_kilograms)).format('0,0.00'); */
            items.push(item);
          }
          this.data = items;
        })
        .catch((error) => console.log(errors));
    },

    getProductSet(a) {
      this.$axios
        .get("/production/get_product_set/" + a)
        .then((res) => {
          this.selectOptions.product_types = res.data.product_types;
        })
        .catch((error) => console.log("Product not selected."));
    }
  }
};
</script>

<style>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
